export default __webpack_public_path__ + "static/media/Extraction.16bc4658.svg";